export default function(ths = [], permissions) {
  return ths.filter(item => {
    if (item.hide) {
      return null
    }
    if (item.displayForRoles) {
      return item.displayForRoles.some(role => role === permissions.activeRole)
    }
    if (item.hideForRoles) {
      return !item.hideForRoles.some(role => role === permissions.activeRole)
    }

    return item
  })
}
